var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { useAssemblySearchContext } from '../../state/assemblySearch';
import { getAssemblySearchExportResults } from '../../services/TempAssemblySearchApiService';
import { COMPONENT_MAP } from '../constants/COMPONENT_MAP';
import { toResultRow } from './TempAssemblySearchResults'; // same columns and headers as MatchingAssemblies/ExportToCsvConverter, minus the hidden Id column
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var exportHeaders = COMPONENT_MAP.PrivateAssemblyView.colHeads.slice(1).map(function (header) { return header.name; });
var toCsvCell = function (value) { return "\"".concat(value.replaceAll('"', '""'), "\""); };
export var buildAssemblyCsv = function (results) { return __spreadArray([exportHeaders.join(',')], results.map(function (result) { return toResultRow(result, true).slice(1).map(toCsvCell).join(','); }), true).join('\r\n'); };
var toTimestamp = function (date) { return date.getFullYear() + [date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()].map(function (part) { return String(part).padStart(2, '0'); }).join(''); };
export var TempExportToCsvConverter = function () { var state = useAssemblySearchContext().state; var _a = useState(false), loading = _a[0], setLoading = _a[1]; var _b = useState(false), error = _b[0], setError = _b[1]; var handleDownloadCsv = function () { return __awaiter(void 0, void 0, void 0, function () { var results, blob, url, link, _a; return __generator(this, function (_b) {
    switch (_b.label) {
        case 0:
            setLoading(true);
            setError(false);
            _b.label = 1;
        case 1:
            _b.trys.push([1, 3, 4, 5]);
            return [4 /*yield*/, getAssemblySearchExportResults(state)];
        case 2:
            results = _b.sent();
            if (results.length === 0)
                return [2 /*return*/];
            blob = new Blob([buildAssemblyCsv(results)], { type: 'text/csv;charset=utf-8;' });
            url = URL.createObjectURL(blob);
            link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "exported_assemblies_".concat(toTimestamp(new Date()), ".csv"));
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
            return [3 /*break*/, 5];
        case 3:
            _a = _b.sent();
            setError(true);
            return [3 /*break*/, 5];
        case 4:
            setLoading(false);
            return [7 /*endfinally*/];
        case 5: return [2 /*return*/];
    }
}); }); }; return /*#__PURE__*/ _jsxs(Box, { className: "d-flex align-items-center p-3", children: [/*#__PURE__*/ _jsx(Button, { variant: "contained", onClick: handleDownloadCsv, disabled: loading, startIcon: loading ? /*#__PURE__*/ _jsx(CircularProgress, { size: 16, color: "inherit" }) : undefined, children: loading ? 'Downloading...' : 'Export & Download CSV' }), error && /*#__PURE__*/ _jsx("span", { className: "ml-3 text-danger", children: "Export failed. Please try again." })] }); };
